var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckoutArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55309 0.586958L15.3217 5.67391C16.0243 6.29348 16.1811 7.00239 15.7921 7.80065C15.4045 8.60022 14.7115 9 13.7131 9L2.28687 9C1.28845 9 0.59548 8.60022 0.207949 7.80065C-0.181063 7.00239 -0.0242751 6.29348 0.678311 5.67392L6.44691 0.586958C6.66878 0.391305 6.90914 0.244568 7.16799 0.146741C7.42684 0.0489147 7.70417 7.25244e-07 8 6.99382e-07C8.29583 6.7352e-07 8.57316 0.0489146 8.83201 0.146741C9.09086 0.244568 9.33122 0.391305 9.55309 0.586958Z",
    fill: "#026F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutArrowUp);
export default __webpack_public_path__ + "static/media/checkout-arrow-up.d9a2f93c08cfc71d6ede04a7737bc059.svg";
export { ForwardRef as ReactComponent };